module.exports = __webpack_public_path__ + "img/img (13).40d8f9ec.png";